import { UntypedFormControl, UntypedFormArray } from '@angular/forms';

export class UserAttribute {
  name: UntypedFormControl;
  value: UntypedFormArray;
  uom: UntypedFormControl;
  uom_label: UntypedFormControl;
  // only for PAdb
  attribute_id: UntypedFormControl;
  valid_attribute_values: UntypedFormControl;
  is_padb: UntypedFormControl;
  style_id: UntypedFormControl;
  assignment_id: UntypedFormControl;
}
